import React, { useMemo } from "react";
import {
  FaBell,
  FaEnvelope,
  FaExclamationTriangle,
  FaTrash,
} from "react-icons/fa";

import { formatDateRange } from "../utils/communicationSettingsUtils";

function getIcon(type) {
  if (type === "messages") return <FaEnvelope />;
  return <FaBell />;
}

export default function CommunicationPurgeCard({
  type = "notifications",
  title,
  description,
  count,
  loading,
  form,
  setField,
  submitting,
  buttonLabel,
  dangerLabel,
  onSubmit,
}) {
  const prettyRange = useMemo(() => {
    return formatDateRange(form.startDate, form.endDate);
  }, [form.startDate, form.endDate]);

  const icon = getIcon(type);

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Purge
            </p>

            <h3 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
                {icon}
              </span>
              {title}
            </h3>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              {description}
            </p>
          </div>

          <span className="inline-flex shrink-0 items-center justify-center rounded-2xl bg-slate-100 px-3 py-2 text-xs font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-200">
            {loading ? "…" : count} élément(s)
          </span>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
                Date de début
              </label>

              <input
                type="date"
                value={form.startDate}
                onChange={(event) => setField("startDate", event.target.value)}
                max={form.endDate || undefined}
                required
                className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-medium text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-bold text-slate-700 dark:text-slate-200">
                Date de fin
              </label>

              <input
                type="date"
                value={form.endDate}
                onChange={(event) => setField("endDate", event.target.value)}
                min={form.startDate || undefined}
                required
                className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-medium text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
              />
            </div>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs leading-5 text-slate-600 dark:text-slate-300">
              Période sélectionnée :{" "}
              <span className="font-bold text-slate-800 dark:text-slate-100">
                {prettyRange}
              </span>
            </p>
          </div>

          <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 dark:border-rose-500/20 dark:bg-rose-500/10">
            <p className="flex items-start gap-2 text-xs leading-5 text-rose-700 dark:text-rose-300">
              <FaExclamationTriangle className="mt-0.5 shrink-0" />
              <span>
                {dangerLabel} Cette action est{" "}
                <span className="font-bold">définitive</span>.
              </span>
            </p>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={submitting}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-rose-600 px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <FaTrash />
              {submitting ? "Suppression..." : buttonLabel}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}